// src/translations.js

export const translations = {
  en: {
    greeting: "I'm Berk!",
    role: "Software Developer",
    location: "Atlanta, Georgia",
    projects: "Latest Projects",
    lingProjects: "Linguistics Projects",
    tools: "Tools",
    about: "About Me!",
    aboutBody: "I am a Software Developer studying CS at Georgia Tech with a love of languages and linguistics!",
    languages: "Languages",
    clickStart: "Click to Start",
    clickMore: "Click for more",
    resume: "Résumé",
    
    // Tools Page
    toolsDesc: "A snapshot of the tools and technologies I use daily, along with those I'm familiar with.",
    myEveryday: "My Everyday",
    familiarWith: "Familiar With",

    // SHORT DESCRIPTIONS (Dashboard)
    budgetizeDesc: "Automated grocery price comparison tool using web scraping.",
    heceleDesc: "A fast-paced Turkish syllable puzzle game inspired by Bomb Party.",
    wordleDesc: "A Turkish language adaptation of the daily word puzzle game.",
    scriptleDesc: "A flashcard application for learning world writing systems.",
    isimbulDesc: "Interactive visualization of Turkish name etymology and statistics.",
    posTaggerDesc: "A real-time morphological analysis tool for Turkish text.",
    
    // LONG DESCRIPTIONS (Projects Page)
    budgetizeDescLong: "Full-stack webapp allowing users to compare grocery prices in various grocery stores. Automatic data collection through webscraping.",
    heceleDescLong: "A single player version of the game Bomb Party by JKLM in Turkish using Turkish words and syllables.",
    wordleDescLong: "A version of the popular Wordle game using Turkish words.",
    scriptleDescLong: "Flashcard-style app for mastering world writing systems (Cyrillic, Katakana, etc.). Features strict mode and mastery tracking.",
    isimbulDescLong: "Interactive explorer for Turkish name etymology and statistics. Features force-directed graphs for semantic connections.",
    posTaggerDescLong: "Web-based tool for real-time morphological analysis of Turkish text. Backend powered by Zemberek-Python.",
  },
  tr: {
    greeting: "Ben Berk!",
    role: "Yazılım Geliştirici",
    location: "Atlanta, Georgia",
    projects: "Son Projeler",
    lingProjects: "Dilbilimi Projeleri",
    tools: "Araçlar",
    about: "Hakkımda",
    aboutBody: "Georgia Tech'te Bilgisayar Bilimleri okuyan, dilbilimi alanı ile ilgilenen bir Yazılım Geliştiriciyim.",
    languages: "Diller",
    clickStart: "Başlamak için Tıkla",
    clickMore: "Daha fazlası için tıkla",
    resume: "Özgeçmiş",
    
    // Tools Page
    toolsDesc: "Günlük kullandığım araçlar ve teknolojiler ile aşina olduklarımın bir özeti.",
    myEveryday: "Gündelik Kullandıklarım",
    familiarWith: "Aşina Olduklarım",

    // SHORT
    budgetizeDesc: "Web kazıma kullanan otomatik market fiyat karşılaştırma aracı.",
    heceleDesc: "Bomb Party'den esinlenen hızlı tempolu Türkçe hece oyunu.",
    wordleDesc: "Günlük kelime bulmaca oyununun Türkçe uyarlaması.",
    scriptleDesc: "Dünya yazı sistemlerini öğrenmek için flashcard uygulaması.",
    isimbulDesc: "Türkçe isim kökenleri ve istatistikleri için görselleştirme aracı.",
    posTaggerDesc: "Türkçe metinler için gerçek zamanlı morfolojik analiz aracı.",

    // LONG
    budgetizeDescLong: "Kullanıcıların çeşitli marketlerdeki gıda fiyatlarını karşılaştırmasını sağlayan full-stack web uygulaması. Web kazıma ile otomatik veri toplama.",
    heceleDescLong: "JKLM tarafından yapılan Bomb Party oyununun Türkçe kelimeler ve heceler kullanılarak yapılan tek oyunculu versiyonu.",
    wordleDescLong: "Popüler Wordle oyununun Türkçe kelimeler kullanan bir versiyonu.",
    scriptleDescLong: "Dünya yazı sistemlerini (Kiril, Katakana vb.) öğrenmek için flashcard tarzı uygulama. Katı mod ve ustalık takibi içerir.",
    isimbulDescLong: "Türkçe isim kökenbilimi ve istatistikleri için etkileşimli kaşif. Anlamsal bağlantılar için kuvvet yönelimli grafikler içerir.",
    posTaggerDescLong: "Türkçe metinlerin gerçek zamanlı morfolojik analizi için web tabanlı araç. Altyapı Zemberek-Python ile güçlendirilmiştir.",
  },
  fr: {
    greeting: "Je suis Berk !",
    role: "Développeur Logiciel",
    location: "Atlanta, Géorgie",
    projects: "Derniers Projets",
    lingProjects: "Projets Linguistiques",
    tools: "Outils",
    about: "À propos de moi",
    aboutBody: "Je suis développeur logiciel, étudiant l'informatique à Georgia Tech, qui est passionné par les langues et la linguistique !",
    languages: "Langues",
    clickStart: "Cliquez pour commencer",
    clickMore: "En savoir plus",
    resume: "CV",

    // Tools Page
    toolsDesc: "Un aperçu des outils et technologies que j'utilise quotidiennement, ainsi que ceux avec lesquels je suis familier.",
    myEveryday: "Mon quotidien",
    familiarWith: "Familier avec",
    
    // SHORT
    budgetizeDesc: "Outil de comparaison des prix alimentaires par web scraping.",
    heceleDesc: "Jeu de puzzle syllabique turc rapide inspiré de Bomb Party.",
    wordleDesc: "Adaptation en langue turque du jeu de mots quotidien.",
    scriptleDesc: "Application de cartes mémoire pour apprendre les systèmes d'écriture.",
    isimbulDesc: "Visualisation interactive de l'étymologie des noms turcs.",
    posTaggerDesc: "Outil d'analyse morphologique en temps réel pour le texte turc.",

    // LONG
    budgetizeDescLong: "Application web full-stack permettant de comparer les prix dans divers supermarchés. Collecte automatique de données par web scraping.",
    heceleDescLong: "Une version solo du jeu Bomb Party de JKLM en turc utilisant des mots et des syllabes turcs.",
    wordleDescLong: "Une version du jeu populaire Wordle utilisant des mots turcs.",
    scriptleDescLong: "Application de type flashcard pour maîtriser les systèmes d'écriture du monde (cyrillique, katakana, etc.).",
    isimbulDescLong: "Explorateur interactif pour l'étymologie et les statistiques des noms turcs. Comprend des graphiques de force pour les connexions sémantiques.",
    posTaggerDescLong: "Outil web pour l'analyse morphologique en temps réel du texte turc. Backend propulsé par Zemberek-Python.",
  },
  ru: {
    greeting: "Я Берк!",
    role: "Разработчик ПО",
    location: "Атланта, Джорджия",
    projects: "Последние проекты",
    lingProjects: "Лингвистические проекты",
    tools: "Инструменты",
    about: "Обо мне",
    aboutBody: "Я разработчик ПО, изучаю информатику в Georgia Tech и увлекаюсь языками и лингвистикой.",
    languages: "Языки",
    clickStart: "Нажмите, чтобы начать",
    clickMore: "Подробнее",
    resume: "Резюме",
    
    // Tools Page
    toolsDesc: "Обзор инструментов и технологий, которые я использую ежедневно, а также тех, с которыми я знаком.",
    myEveryday: "Мой повседневный набор",
    familiarWith: "Знаком с",

    // SHORT
    budgetizeDesc: "Инструмент сравнения цен на продукты с использованием веб-скрейпинга.",
    heceleDesc: "Быстрая игра со слогами на турецком, вдохновленная Bomb Party.",
    wordleDesc: "Адаптация популярной игры в слова для турецкого языка.",
    scriptleDesc: "Приложение с карточками для изучения систем письма мира.",
    isimbulDesc: "Интерактивная визуализация этимологии и статистики турецких имен.",
    posTaggerDesc: "Инструмент морфологического анализа турецкого текста.",

    // LONG
    budgetizeDescLong: "Full-stack веб-приложение для сравнения цен в продуктовых магазинах. Автоматический сбор данных через веб-скрейпинг.",
    heceleDescLong: "Одиночная версия игры Bomb Party от JKLM на турецком языке с использованием турецких слов и слогов.",
    wordleDescLong: "Версия популярной игры Wordle с использованием турецких слов.",
    scriptleDescLong: "Приложение с карточками для изучения систем письма мира (кириллица, катакана и др.). Включает строгий режим.",
    isimbulDescLong: "Интерактивный обозреватель этимологии и статистики турецких имен. Содержит силовые графы для семантических связей.",
    posTaggerDescLong: "Веб-инструмент для морфологического анализа турецкого текста в реальном времени. Бэкенд на Zemberek-Python.",
  },
  az: {
    greeting: "Mən Berk!",
    role: "Proqram Tərtibatçısı",
    location: "Atlanta, Corciya",
    projects: "Son Layihələr",
    lingProjects: "Dilçilik Layihələri",
    tools: "Alətlər",
    about: "Haqqımda",
    aboutBody: "Georgia Tech-də Kompüter Elmləri təhsili alan, dilçilik həvəsi olan proqramçıyam.",
    languages: "Dillər",
    clickStart: "Başlamaq üçün klikləyin",
    clickMore: "Daha çoxu üçün klikləyin",
    resume: "CV",

    // Tools Page
    toolsDesc: "Gündəlik istifadə etdiyim alətlər və texnologiyalar, həmçinin tanış olduqlarımın icmalı.",
    myEveryday: "Gündəlik İstifadə etdiklərim",
    familiarWith: "Tanış Olduqlarım",
    
    // SHORT
    budgetizeDesc: "Veb skrapinq istifadə edən avtomatlaşdırılmış qiymət aləti.",
    heceleDesc: "Bomb Party-dən ilhamlanmış sürətli türk heca oyunu.",
    wordleDesc: "Gündəlik söz oyununun türk dilinə uyğunlaşdırılması.",
    scriptleDesc: "Dünya yazı sistemlərini öyrənmək üçün fleşkart tətbiqi.",
    isimbulDesc: "Türk adlarının etimologiyası və statistikası üçün vizualizasiya aləti.",
    posTaggerDesc: "Türk dili mətnləri üçün real vaxtlı morfoloji analiz aləti.",

    // LONG
    budgetizeDescLong: "İstifadəçilərə müxtəlif ərzaq mağazalarında qiymətləri müqayisə etməyə imkan verən full-stack veb tətbiqi.",
    heceleDescLong: "JKLM tərəfindən hazırlanmış Bomb Party oyununun türk sözləri və hecaları ilə tək oyunçu versiyası.",
    wordleDescLong: "Məşhur Wordle oyununun türk sözləri ilə versiyası.",
    scriptleDescLong: "Dünya yazı sistemlərini (Kiril, Katakana və s.) öyrənmək üçün fleşkart tərzi tətbiq. Ciddi rejim və ustalıq izləmə xüsusiyyətləri var.",
    isimbulDescLong: "Türk adlarının etimologiyası və statistikası üçün interaktiv bələdçi. Semantik əlaqələr üçün qüvvət yönlü qrafiklər ehtiva edir.",
    posTaggerDescLong: "Türk dilində mətnlərin real vaxt rejimində morfoloji analizi üçün veb əsaslı alət. Zemberek-Python ilə işləyir.",
  }
};